import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store";
import ModalContainer from "../../ModalContainer.tsx";
import { PanelBody } from "../../panel/panel.jsx";
import CustomSelectField from "../../formik/CustomSelectField.tsx";
import SucursalesModalPuestos from "./SucursalesModalPuestos.tsx";
import { setPositions } from "../../../store/slices/sucursalesSlice.ts";

const SucursalesFormPuestos = ({
  formik,
  error,
  templates,
  loadingPositions = false,
}) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = React.useState(false);
  const [currentRecord, setCurrentRecord] = React.useState(null);
  const { positionsOriginal } = useSelector(
    (state: RootState) => state.sucursales
  );

  const handleChange = async () => {
    const plantillaSeleccionada = templates.find(
      (template) => template.id === formik.values.branchTemplate
    );

    if (!plantillaSeleccionada || !plantillaSeleccionada.positions) {
      formik.setFieldValue("puestos", []);
      return;
    }

    if (
      !Array.isArray(plantillaSeleccionada.positions) ||
      plantillaSeleccionada.positions.length === 0
    ) {
      formik.setFieldValue("puestos", []);
      return;
    }

    const positionsByPuesto = plantillaSeleccionada.positions.reduce(
      (acc, current) => {
        if (!current || !current.position || !current.position.id) {
          return acc;
        }

        const positionId = current.position.id;
        if (!acc[positionId]) {
          acc[positionId] = [];
        }
        acc[positionId].push(current);
        return acc;
      },
      {}
    );

    const groupedPositions = (Object.values(positionsByPuesto) as any[])
      .map((positionGroup: any[]) => {
        if (!positionGroup || positionGroup.length === 0) return null;

        const firstPosition = positionGroup[0];
        const positionId = firstPosition.position.id;

        const showScheduleValue = firstPosition.showSchedule === true;
        const isHireValue = firstPosition.isHire === true;
        const isEssencialValue = firstPosition.isEssencial === true;

        let matutino = 0;
        let intermedio = 0;
        let vespertino = 0;

        positionGroup.forEach((p) => {
          if (p.shifts && typeof p.shifts === "string") {
            if (p.shifts.includes("Matutino")) {
              matutino += Number(p.numberOfWorkers) || 0;
            }
            if (p.shifts.includes("Intermedio")) {
              intermedio += Number(p.numberOfWorkers) || 0;
            }
            if (p.shifts.includes("Vespertino")) {
              vespertino += Number(p.numberOfWorkers) || 0;
            }
          }
        });

        return {
          puesto: positionId,
          matutino,
          intermedio,
          vespertino,
          showSchedule: showScheduleValue,
          isHire: isHireValue,
          isEssencial: isEssencialValue,
        };
      })
      .filter((p) => p !== null);

    if (groupedPositions && groupedPositions.length > 0) {
      await new Promise((resolve) => setTimeout(resolve, 100));
      formik.setFieldValue("puestos", groupedPositions);
    } else {
      formik.setFieldValue("puestos", []);
    }
  };

  const handleDelete = (index) => {
    const remainingPositions = [...positionsOriginal];
    dispatch(setPositions(remainingPositions));

    const newPuestos = formik.values.puestos.filter((_, i) => i !== index);
    formik.setFieldValue("puestos", newPuestos);
  };

  const [selectedPositions, setSelectedPositions] = React.useState<number[]>(
    []
  );

  const handleCheckboxChange = (index: number) => {
    setSelectedPositions((prevSelected: number[]) => {
      if (prevSelected.includes(index)) {
        return prevSelected.filter((i) => i !== index);
      } else {
        return [...prevSelected, index];
      }
    });
  };

  const handleDeleteSelected = () => {
    const newPuestos = formik.values.puestos.filter(
      (_, i) => !selectedPositions.includes(i)
    );
    formik.setFieldValue("puestos", newPuestos);
    setSelectedPositions([]);
  };

  const [isInitialLoad, setIsInitialLoad] = React.useState(true);
  const previousBranchTemplate = React.useRef<number | null>(null);
  const hasLoadedFromBackend = React.useRef(false);

  React.useEffect(() => {
    if (
      formik.values.puestos &&
      formik.values.puestos.length > 0 &&
      !hasLoadedFromBackend.current
    ) {
      const firstPuesto = formik.values.puestos[0];
      if (
        firstPuesto &&
        firstPuesto.puesto &&
        typeof firstPuesto.showSchedule === "boolean"
      ) {
        hasLoadedFromBackend.current = true;
        setIsInitialLoad(false);
      }
    }
  }, [formik.values.puestos]);

  useEffect(() => {
    if (hasLoadedFromBackend.current) {
      if (formik.values.branchTemplate !== -99) {
        previousBranchTemplate.current = formik.values.branchTemplate;
      }
      return;
    }

    if (
      formik.values.branchTemplate !== -99 &&
      templates?.length &&
      previousBranchTemplate.current !== null &&
      previousBranchTemplate.current !== formik.values.branchTemplate &&
      !isInitialLoad
    ) {
      console.log(
        "useEffect - Cambio manual de plantilla",
        formik.values.branchTemplate
      );
      handleChange();
    }

    if (formik.values.branchTemplate !== -99) {
      previousBranchTemplate.current = formik.values.branchTemplate;
    }

    if (isInitialLoad && formik.values.branchTemplate !== -99) {
      setIsInitialLoad(false);
    }
  }, [formik.values.branchTemplate, templates]);

  console.log("formik.values.puestos", formik.values.puestos);

  return (
    <div>
      <PanelBody>
        <div style={{ display: "flex", flexDirection: "row", marginTop: "1%" }}>
          <div className="col-md-1" />
          <div className="col-md-10">
            <div className="col-md-9 d-flex flex-row">
              <CustomSelectField
                formik={formik}
                field="branchTemplate"
                list={templates ?? []}
                label="Plantilla"
                disabled={!!currentRecord}
                onChange={() => {
                  hasLoadedFromBackend.current = false;
                  handleChange();
                }}
                sm={5}
              />
            </div>
            <button
              type="button"
              className={`mt-5 btn btn-outline-${
                error ? "danger" : "secondary"
              }`}
              onClick={() => setShowModal(true)}
            >
              <i className="fas fa-plus"></i> Agregar puesto
            </button>

            {error && (
              <div className="text-danger mt-1" role="alert">
                {error}
              </div>
            )}

            <div
              style={{
                border: "1px solid #e0e0e0",
                borderRadius: "8px",
                overflow: "hidden",
                backgroundColor: "#fff",
                marginTop: "16px",
              }}
            >
              {loadingPositions ? (
                <div style={{ padding: "20px" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr
                        style={{
                          backgroundColor: "#f8f9fa",
                          borderBottom: "2px solid #e0e0e0",
                        }}
                      >
                        <th
                          style={{
                            padding: "12px 16px",
                            textAlign: "left",
                            width: "40px",
                          }}
                        ></th>
                        <th
                          style={{
                            padding: "12px 16px",
                            textAlign: "left",
                            fontSize: "12px",
                            fontWeight: "600",
                            color: "#666",
                            textTransform: "uppercase",
                          }}
                        >
                          Puesto
                        </th>
                        <th
                          style={{
                            padding: "12px 16px",
                            textAlign: "center",
                            fontSize: "12px",
                            fontWeight: "600",
                            color: "#666",
                            textTransform: "uppercase",
                          }}
                        >
                          Matutino
                        </th>
                        <th
                          style={{
                            padding: "12px 16px",
                            textAlign: "center",
                            fontSize: "12px",
                            fontWeight: "600",
                            color: "#666",
                            textTransform: "uppercase",
                          }}
                        >
                          Intermedio
                        </th>
                        <th
                          style={{
                            padding: "12px 16px",
                            textAlign: "center",
                            fontSize: "12px",
                            fontWeight: "600",
                            color: "#666",
                            textTransform: "uppercase",
                          }}
                        >
                          Vespertino
                        </th>
                        <th
                          style={{
                            padding: "12px 16px",
                            textAlign: "center",
                            fontSize: "12px",
                            fontWeight: "600",
                            color: "#666",
                            textTransform: "uppercase",
                          }}
                        >
                          Horario
                        </th>
                        <th
                          style={{
                            padding: "12px 16px",
                            textAlign: "center",
                            fontSize: "12px",
                            fontWeight: "600",
                            color: "#666",
                            textTransform: "uppercase",
                          }}
                        >
                          Contratable
                        </th>
                        <th
                          style={{
                            padding: "12px 16px",
                            textAlign: "center",
                            fontSize: "12px",
                            fontWeight: "600",
                            color: "#666",
                            textTransform: "uppercase",
                          }}
                        >
                          Esencial
                        </th>
                        <th
                          style={{
                            padding: "12px 16px",
                            textAlign: "center",
                            fontSize: "12px",
                            fontWeight: "600",
                            color: "#666",
                            textTransform: "uppercase",
                            width: "60px",
                          }}
                        >
                          Acción
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {[1, 2, 3].map((skeletonIndex) => (
                        <tr
                          key={skeletonIndex}
                          style={{
                            borderBottom:
                              skeletonIndex < 3 ? "1px solid #f0f0f0" : "none",
                          }}
                        >
                          <td
                            style={{
                              padding: "12px 16px",
                              textAlign: "center",
                            }}
                          >
                            <div
                              className="skeleton"
                              style={{
                                width: "18px",
                                height: "18px",
                                borderRadius: "4px",
                                backgroundColor: "#e0e0e0",
                                animation: "pulse 1.5s ease-in-out infinite",
                              }}
                            ></div>
                          </td>
                          <td style={{ padding: "12px 16px" }}>
                            <div
                              className="skeleton"
                              style={{
                                width: "150px",
                                height: "16px",
                                borderRadius: "4px",
                                backgroundColor: "#e0e0e0",
                                animation: "pulse 1.5s ease-in-out infinite",
                              }}
                            ></div>
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              textAlign: "center",
                            }}
                          >
                            <div
                              className="skeleton"
                              style={{
                                width: "30px",
                                height: "16px",
                                borderRadius: "4px",
                                backgroundColor: "#e0e0e0",
                                margin: "0 auto",
                                animation: "pulse 1.5s ease-in-out infinite",
                              }}
                            ></div>
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              textAlign: "center",
                            }}
                          >
                            <div
                              className="skeleton"
                              style={{
                                width: "30px",
                                height: "16px",
                                borderRadius: "4px",
                                backgroundColor: "#e0e0e0",
                                margin: "0 auto",
                                animation: "pulse 1.5s ease-in-out infinite",
                              }}
                            ></div>
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              textAlign: "center",
                            }}
                          >
                            <div
                              className="skeleton"
                              style={{
                                width: "30px",
                                height: "16px",
                                borderRadius: "4px",
                                backgroundColor: "#e0e0e0",
                                margin: "0 auto",
                                animation: "pulse 1.5s ease-in-out infinite",
                              }}
                            ></div>
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              textAlign: "center",
                            }}
                          >
                            <div
                              className="skeleton"
                              style={{
                                width: "20px",
                                height: "20px",
                                borderRadius: "50%",
                                backgroundColor: "#e0e0e0",
                                margin: "0 auto",
                                animation: "pulse 1.5s ease-in-out infinite",
                              }}
                            ></div>
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              textAlign: "center",
                            }}
                          >
                            <div
                              className="skeleton"
                              style={{
                                width: "20px",
                                height: "20px",
                                borderRadius: "50%",
                                backgroundColor: "#e0e0e0",
                                margin: "0 auto",
                                animation: "pulse 1.5s ease-in-out infinite",
                              }}
                            ></div>
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              textAlign: "center",
                            }}
                          >
                            <div
                              className="skeleton"
                              style={{
                                width: "20px",
                                height: "20px",
                                borderRadius: "50%",
                                backgroundColor: "#e0e0e0",
                                margin: "0 auto",
                                animation: "pulse 1.5s ease-in-out infinite",
                              }}
                            ></div>
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              textAlign: "center",
                            }}
                          >
                            <div
                              className="skeleton"
                              style={{
                                width: "24px",
                                height: "24px",
                                borderRadius: "4px",
                                backgroundColor: "#e0e0e0",
                                margin: "0 auto",
                                animation: "pulse 1.5s ease-in-out infinite",
                              }}
                            ></div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <style>{`
                    @keyframes pulse {
                      0%, 100% {
                        opacity: 1;
                      }
                      50% {
                        opacity: 0.5;
                      }
                    }
                  `}</style>
                </div>
              ) : formik.values.puestos.length === 0 ? (
                <div
                  style={{
                    padding: "40px",
                    textAlign: "center",
                    color: "#999",
                  }}
                >
                  <i
                    className="fa fa-inbox"
                    style={{
                      fontSize: "48px",
                      marginBottom: "16px",
                      display: "block",
                    }}
                  ></i>
                  <p style={{ margin: 0, fontSize: "16px" }}>
                    No hay puestos agregados
                  </p>
                </div>
              ) : (
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr
                      style={{
                        backgroundColor: "#f8f9fa",
                        borderBottom: "2px solid #e0e0e0",
                      }}
                    >
                      <th
                        style={{
                          padding: "12px 16px",
                          textAlign: "left",
                          width: "40px",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={
                            selectedPositions.length ===
                              formik.values.puestos.filter((doc) => {
                                const position = positionsOriginal.find(
                                  (position) =>
                                    position.id === doc.puesto ||
                                    position.id === doc.id
                                );
                                return position && !position.isDelete;
                              }).length && selectedPositions.length > 0
                          }
                          onChange={(e) => {
                            if (e.target.checked) {
                              const allIndices = formik.values.puestos
                                .map((_, i) => i)
                                .filter((_, i) => {
                                  const doc = formik.values.puestos[i];
                                  const position = positionsOriginal.find(
                                    (position) =>
                                      position.id === doc.puesto ||
                                      position.id === doc.id
                                  );
                                  return position && !position.isDelete;
                                });
                              setSelectedPositions(allIndices);
                            } else {
                              setSelectedPositions([]);
                            }
                          }}
                          style={{
                            cursor: "pointer",
                            width: "18px",
                            height: "18px",
                            accentColor: "#007bff",
                          }}
                        />
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          textAlign: "left",
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#666",
                          textTransform: "uppercase",
                        }}
                      >
                        Puesto
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          textAlign: "center",
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#666",
                          textTransform: "uppercase",
                        }}
                      >
                        Matutino
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          textAlign: "center",
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#666",
                          textTransform: "uppercase",
                        }}
                      >
                        Intermedio
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          textAlign: "center",
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#666",
                          textTransform: "uppercase",
                        }}
                      >
                        Vespertino
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          textAlign: "center",
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#666",
                          textTransform: "uppercase",
                        }}
                      >
                        Horario
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          textAlign: "center",
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#666",
                          textTransform: "uppercase",
                        }}
                      >
                        Contratable
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          textAlign: "center",
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#666",
                          textTransform: "uppercase",
                        }}
                      >
                        Esencial
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          textAlign: "center",
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#666",
                          textTransform: "uppercase",
                          width: "60px",
                        }}
                      >
                        Acción
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {formik.values.puestos
                      .filter((doc) => {
                        const position = positionsOriginal.find(
                          (position) =>
                            position.id === doc.puesto || position.id === doc.id
                        );
                        return position && !position.isDelete;
                      })
                      .map((doc, index, array) => (
                        <tr
                          key={index}
                          style={{
                            borderBottom:
                              index < array.length - 1
                                ? "1px solid #f0f0f0"
                                : "none",
                            transition: "background-color 0.2s ease",
                            backgroundColor: "#fff",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#f8f9fa";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = "#fff";
                          }}
                        >
                          <td
                            style={{
                              padding: "12px 16px",
                              textAlign: "center",
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={selectedPositions.includes(index)}
                              onChange={() => handleCheckboxChange(index)}
                              style={{
                                cursor: "pointer",
                                width: "18px",
                                height: "18px",
                                accentColor: "#007bff",
                              }}
                            />
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#333",
                            }}
                          >
                            {positionsOriginal.find(
                              (position) =>
                                position.id === doc.puesto ||
                                position.id === doc.id
                            )?.name || "Sin nombre"}
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              textAlign: "center",
                              fontSize: "14px",
                              color: "#555",
                            }}
                          >
                            {doc.matutino || 0}
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              textAlign: "center",
                              fontSize: "14px",
                              color: "#555",
                            }}
                          >
                            {doc.intermedio || 0}
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              textAlign: "center",
                              fontSize: "14px",
                              color: "#555",
                            }}
                          >
                            {doc.vespertino || 0}
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              textAlign: "center",
                            }}
                          >
                            <i
                              className={`fa ${
                                doc.showSchedule === true
                                  ? "fa-check-circle text-success"
                                  : "fa-times-circle text-danger"
                              }`}
                              style={{ fontSize: "20px" }}
                              title={
                                doc.showSchedule === true
                                  ? "Mostrar en horario"
                                  : "No mostrar en horario"
                              }
                            ></i>
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              textAlign: "center",
                            }}
                          >
                            <i
                              className={`fa ${
                                doc.isHire === true
                                  ? "fa-check-circle text-success"
                                  : "fa-times-circle text-danger"
                              }`}
                              style={{ fontSize: "20px" }}
                              title={
                                doc.isHire === true
                                  ? "Contratable"
                                  : "No contratable"
                              }
                            ></i>
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              textAlign: "center",
                            }}
                          >
                            <i
                              className={`fa ${
                                doc.isEssencial === true
                                  ? "fa-check-circle text-success"
                                  : "fa-times-circle text-danger"
                              }`}
                              style={{ fontSize: "20px" }}
                              title={
                                doc.isEssencial === true
                                  ? "Esencial"
                                  : "No esencial"
                              }
                            ></i>
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              textAlign: "center",
                            }}
                          >
                            <a
                              href="#/"
                              onClick={(e) => {
                                e.preventDefault();
                                setCurrentRecord(doc);
                                setShowModal(true);
                              }}
                              style={{
                                color: "#007bff",
                                textDecoration: "none",
                                padding: "6px 8px",
                                borderRadius: "4px",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                transition: "background-color 0.2s ease",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "#e7f3ff";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "transparent";
                              }}
                              title="Editar puesto"
                            >
                              <i
                                className="fa fa-pen"
                                style={{ fontSize: "16px", cursor: "pointer" }}
                              ></i>
                            </a>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              )}
            </div>

            {selectedPositions.length > 0 && (
              <button
                type="button"
                className="btn btn-danger mt-3"
                onClick={handleDeleteSelected}
              >
                <i className="fa fa-trash  text-white"></i>
                <span className="ms-2 text-white"> Eliminar seleccionados</span>
              </button>
            )}
          </div>
        </div>
      </PanelBody>
      <ModalContainer
        open={showModal}
        closeFn={() => setShowModal(false)}
        title="Agregar colaboradores"
        children={
          <SucursalesModalPuestos
            fomik={formik}
            closeFn={() => {
              setShowModal(false);
              setCurrentRecord(null);
            }}
            currentRecord={currentRecord}
          />
        }
      />
    </div>
  );
};

export default SucursalesFormPuestos;
